import { styled } from '@mui/material'
import { themeValue } from './Themes'

export const StyledControlInput = styled('div')`
  display: flex;
  align-items: center;
  height: 48px;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.color.text70};
  padding: 0 12px;

  border-radius: 6px 6px 0 0;
  // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;

  background: rgba(30, 35, 41, 1);

  > input {
    width: 100%;
    height: 100%;
    font-size: 14px;
    background-color: transparent;
    color: rgba(255, 255, 255, 1);
    border: none;
    appearance: none;
    outline: none;
  }

  input {
    & + .input-border {
      position: absolute;
      top: 0;
      left: 50%;
      width: 0;
      height: 100%;
      border-bottom: 1px solid
        ${themeValue('rgba(160, 238, 9, 1)', 'rgba(142, 205, 30, 1)')};
      pointer-events: none;
      border-radius: inherit;

      transition:
        width 0.2s ease-in-out,
        left 0.2s ease-in-out;
    }
    :focus {
      & + .input-border {
        width: 100%;
        left: 0;
      }
    }
  }

  // ${(props) => props.theme.breakpoints.down('md')} {
  //   padding-right: 0;
  //   padding-left: 0;
  //
  //   input {
  //     padding-left: 16px;
  //   }
  // }
`
export const StyledControlInputLarge = styled(StyledControlInput)`
  height: 56px;
  color: ${(props) => props.theme.color.text70};
  background-color: rgba(22, 25, 30, 1);
  border: none;
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 2px;
  font-size: 16px;
  position: relative;
`
